import React from 'react';

import { Box, Breadcrumb, Heading, Text, Flash } from '@primer/components'
import { Link } from "react-router-dom";

import WaveHero from '../../components/WaveHero';
import AdviceList from '../../components/AdviceList'
import Seo from '../../components/Seo'
import { useProduct } from '../../hooks/useProduct'

export const MESSAGE_IDS = [
  'C1001',
  'C1002',
  'C4007',
  'C4008',
  'C4009',
  'C4016',
  'C4010',
  'C4011',
  'C4017',
  'C4012',
  'C4013',
  'C4014',
  'C4015',
]


export default function(props) {
  const productDetails = useProduct()
  return (
    <Box>
      <Seo title="Django security best practice" />
      <WaveHero>
        <Box className="container-lg lead text-white pt-2 pb-9 pb-md-8 pt-md-8 pl-4 pl-md-0">
          <Breadcrumb>
            <Breadcrumb.Item as={Link} to={'/'} className="text-white">Home</Breadcrumb.Item>
            <br/>
          </Breadcrumb>
          <Heading className="mb-0 text-white" style={{ display: 'block' }}>Enhance your Django security</Heading>
        </Box>
      </WaveHero>
      <div className="container-lg px-3 mb-9" style={{fontSize: "16px"}}>
        <Box alignItems="center" className="container-lg clearfix d-md-flex">
          <Box className="col-md-6 float-right">
            <img src="/risk.svg" width="100%" alt="Security" />
          </Box>
          <Box className="f3 col-md-6 float-left">
            <Text as="p">Code Review Doctor checks your code follows the Django documentation security best practices, and offers the fix to save you developer effort.</Text>
            <Text as="p" className="mt-4">This gives confidence that your users, business, and reputation are not at risk.</Text>
          </Box>
        </Box>
        <Flash className="f3">Try the <Link to="/features/django/challenge/settings-security" target="_blank">Code Review Doctor security challenge</Link> to see the improvements Code Review Doctor suggests.</Flash>

        <Heading fontSize="4" className="mt-6">Code Review Doctor checks for the following security vulnerabilities:</Heading>

        <AdviceList messageIds={MESSAGE_IDS} />
        <Text as="p" className="f3 pt-md-4">Are you ready to improve your Django security? <a href={productDetails.gitHubMarketplaceLink}>Add {productDetails.name} to GitHub</a>.</Text>
      </div>
    </Box>
  );
}
